import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-muted px-5 py-20 sm:py-28" data-id="element-71" data-mp="1gd7jggs99p9p">
      <div className="mx-auto max-w-2xl" data-id="element-72" data-mp="1gausxf8fm6l1">
        <div className="text-center" data-id="element-73" data-mp="2e0pn5d72816u">
          <span className="eyebrow-rule text-[11px] font-bold uppercase tracking-[0.22em] text-secondary" data-id="element-74" data-mp="2dzobb6i7zao2">
            Hai ancora dubbi?
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-foreground sm:text-[2.6rem]" data-id="element-75" data-mp="241h0z6ifrqv1">
            Domande <span className="italic text-primary" data-id="element-76" data-mp="1z2xen4zxkd25">Frequenti</span>
          </h2>
        </div>

        <div className="mt-10 space-y-3" data-id="element-77" data-mp="soejm98iix9t">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-2xl bg-surface" data-id="element-78" data-mp="phxzrfl0xtrs" data-mpi={index}>
                <h3 data-id="element-79" data-mp="pg3f82do03o8">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-secondary/40" data-id="element-80" data-mp="ugr34f6lk4e8">
                    <span className="text-sm font-bold text-foreground" data-id="element-81" data-mp="6rg8zgjr5892">{faq.q}</span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-secondary transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-82" data-mp="6plno14kje4g" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-83" data-mp="1rka1vpww70d">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.24,
                ease: EASE
              }} className="overflow-hidden" data-id="element-84" data-mp="3jxyjpih5dusy">
                      <p className="px-6 pb-5 text-sm leading-relaxed text-foreground/60" data-id="element-85" data-mp="1kr1aou8efuls">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}